import React from "react";
import {
  Grid,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles
} from "@material-ui/core";
import { useCardStyles } from "../lib/constants";
import { useDispatch, useSelector } from "react-redux";
import { stepTwoTexts } from "../containers/steps/stepTwo";
import { stepOneTitles } from "../containers/steps/stepOne";
import { setPageNumber } from "../epics/pageNumberEpic";
import { checkedCardTitle } from "../epics/stepOneEpics";
import DynamicText from "./DynamicTextComponent";

const sentenceScore = (text) => ({ type: "SENTENCE_SCORE", payload: text });

const useStyles = makeStyles(
  () => ({
    dynamicTextRoot: {
      display: "flex",
      width: "100%",
      flexGrow: 1,
      flexShrink: 1,
      overflow: "hidden"
    },
    headingText: {
      fontSize: "1.2rem"
    }
  }),
  {
    name: "TextCard"
  }
);

export default function TextCard(props) {
  const classes = useStyles();

  const { header, text, onCheck, id, resize } = props;
  const pageNumber = useSelector((state) => state.pageNumber);

  const styleProps = { page: pageNumber, sizeBreak: resize[0] };
  const cardClasses = useCardStyles(styleProps);
  const checkedText = useSelector((state) => state.checkedCardStepOne);

  const [open, setOpen] = React.useState(false);

  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={cardClasses.root}>
      <Typography
        className={cardClasses.flexNoGrowNoShrink}
        variant={"subtitle2"}
        classes={{ root: classes.headingText }}
        style={{ paddingTop: "10px" }}
      >
        {header}
      </Typography>
      <div className={classes.dynamicTextRoot}>
        <DynamicText onReadMoreClick={() => handleClickOpen()}>{text}</DynamicText>
      </div>
      <Dialog open={open} onClose={handleClose} classes={{ paper: cardClasses.dialogStyling }}>
        <DialogTitle id={header} classes={{ root: cardClasses.dialogHeaderStyling }}>
          {header}
        </DialogTitle>
        <DialogContent classes={{ root: cardClasses.DialogContentContainer }}>
          <DialogContentText id="readmore-content" classes={{ paper: cardClasses.dialogBodyStyling }}>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions classes={{ root: cardClasses.dialogActionStyling }}>
          <Grid container alignItems="center" justifyContent="center" className={cardClasses.closeButtonContainer}>
            <Button
              onClick={handleClose}
              color="primary"
              variant="outlined"
              classes={{ root: cardClasses.dialogButtonStyling }}
            >
              Schließen
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <div style={{ display: "flex", flexGrow: 1, flexShrink: 0 }} />
      <div className={cardClasses.checkBoxContainer}>
        <Button
          variant={checkedText === text ? "contained" : "outlined"}
          classes={{ root: cardClasses.buttonStyling }}
          color="primary"
          onClick={() => {
            if (onCheck !== undefined && checkedText !== text) {
              onCheck(text);
              dispatch(checkedCardTitle(stepOneTitles[id]));
              const txts = [];
              txts.push(text);
              stepTwoTexts.forEach((txt) => {
                txts.push(txt[1]);
              });
              dispatch(sentenceScore(txts));
              dispatch(setPageNumber(pageNumber + 1));
            }
          }}
        >
          {checkedText === text ? "ausgewählt" : "auswählen"}
        </Button>
      </div>
    </div>
  );
}
